import {
  withScriptjs,
  withGoogleMap,
  GoogleMap as ReactGoogleMap,
} from 'react-google-maps'

export const GoogleMap = withScriptjs(withGoogleMap(ReactGoogleMap))
